import { canvasManager } from "appworks/graphics/canvas/canvas-manager";
import { Orientation } from "appworks/graphics/canvas/orientation";
import { Layers } from "appworks/graphics/layers/layers";
import { AbstractControl } from "appworks/ui/controls/abstract-control";
import { uiFlags, UIMenuFlag } from "appworks/ui/flags/ui-flags";
import { DisplayObject } from "pixi.js";
import { SignalBinding } from "signals";

export class EpicMobileRulesControl extends AbstractControl {
    protected binding: SignalBinding;
    protected orienationBinding: SignalBinding;
    protected elements: DisplayObject[];

    constructor(protected layer: Layers) {
        super();

        if (this.binding) {
            this.binding.detach();
        }

        if (this.orienationBinding) {
            this.orienationBinding.detach();
        }

        this.binding = uiFlags.onFlagsUpdated.add(() => {
            this.setVisible(!uiFlags.has(UIMenuFlag.RULES));
        });

        this.orienationBinding = canvasManager.onOrientationChange.add(() => {
            this.orientationUpdate();
        });

        this.elements = [
            "stake_bg",
            "stake_label",
            "stake_value",
            "stake_up",
            "stake_down",
            "spin",
            "turbo_toggle_on",
            "turbo_toggle_off",
            "ui_autoplay_on",
            "ui_autoplay_on"
        ].map((elName) => layer.getByReference(elName, DisplayObject)).filter(Boolean);
    }

    protected setVisible(visible: boolean) {
        this.elements.forEach((element) => {
            element.visible = visible;
        });

        this.orientationUpdate();
    }

    protected orientationUpdate() {
        if (!uiFlags.has(UIMenuFlag.RULES)) {
            return;
        }

        const stakeLabel = this.layer.getByReference("stake_label", DisplayObject);
        const stakeValue = this.layer.getByReference("stake_value", DisplayObject);

        if (!stakeLabel && !stakeValue) {
            return;
        }

        stakeLabel.visible = canvasManager.orientation === Orientation.PORTRAIT;
        stakeValue.visible = canvasManager.orientation === Orientation.PORTRAIT;
    }
}
